import * as constants from './constants';

export function updateProps(payload) {
  return { type: constants.UPDATE_PROPS, payload };
}

export function deleteOrganizationInProfile(payload) {
  return { type: constants.DELETE_ORGANIZATION_IN_PROFILE, payload };
}

const badgeQuery = `query {
  badges {
    name
    logo
    website
    acronym
    badgeId
  }
}`;


export function getBadges() {
  return dispatch => {
    dispatch({ type: constants.GETTING_BADGES_STARTED });
    return fetch(`/proxy/badges?query=${badgeQuery}`, {
      method: 'get',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    })
    .then(res => res.json())
    .then(response => dispatch({ type: constants.GOT_BADGES, payload: response }))
    .catch(err => console.log('err in getting badges', err));
  };
}

export function updateProfileBadges(companyId, memberships) {
  return dispatch => {
    dispatch({ type: constants.EDIT_PROFILE_BADGE_STARTING });
    return fetch(`/proxy/profile/companyBadges/${companyId}`, {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(memberships),
    })
    .then(res => res.json())
    .then(response => dispatch({ type: constants.EDIT_PROFILE_BADGE_FINISHED, payload: response }))
    .catch(err => console.log('err in editing profile badge', err));
  };
}




// WEBPACK FOOTER //
// ./src/app/stores/profile/memberships/actions.js